/* eslint-disable import/prefer-default-export */
import { compose, head, values, omit } from 'ramda';

export const extractResourceData = payload => {
  return compose(
    head,
    values,
    omit(['meta']),
  )(payload);
};



// WEBPACK FOOTER //
// ./src/utils/RestSlice/slices/utils.js